import React from "react";
import Form, { FormItem } from "../Form";
import styles from "./index.module.scss";
import Select from "../FormSelect";
import Switch from "../Switch";
import ResetButton from "./ResetButton";
import { track } from "../../../utils/amplitude";

export default function Filter(props) {
  const {
    components,
    verticals,
    callToActions,
    categories,
    onChange,
    filterParams,
  } = props;

  return (
    <Form onChange={onChange}>
      <FormItem label={"Category"}>
        <Select
          filterParams={filterParams}
          isMulti={true}
          name="categories"
          onChange={(values) => {
            track("paywall_gallery_filter_selected", {
              filter: "categories",
              values,
            });
          }}
          options={categories.map((el) => ({ value: el.id, label: el.name }))}
        />
      </FormItem>
      <FormItem label={"By components"}>
        <Select
          isMulti={true}
          name="components"
          onChange={(values) => {
            track("paywall_gallery_filter_selected", {
              filter: "components",
              values,
            });
          }}
          options={components.map((el) => ({ value: el.id, label: el.name }))}
        />
      </FormItem>
      <FormItem label={"Free trial"}>
        <Switch
          name="free_trial"
          onChange={(values) => {
            track("paywall_gallery_filter_selected", {
              filter: "free_trial",
              values,
            });
          }}
          options={[
            { value: 1, label: "Yes" },
            { value: 0, label: "No" },
          ]}
        />
      </FormItem>

      <div className={styles.resetBox}>
        <FormItem label={"Product Number"}>
          <div className={styles.resetBtn}></div>
          <ResetButton name="products_number" onChange={() => {}} />

          <Switch
            isMulti
            name="products_number"
            onChange={(values) => {
              track("paywall_gallery_filter_selected", {
                filter: "products_number",
                values,
              });
            }}
            options={[
              { value: 1, label: "1" },
              { value: 2, label: "2" },
              { value: 3, label: "3" },
              { value: 4, label: "4" },
              { value: 5, label: "5" },
              { value: 6, label: "6" },
            ]}
          />
        </FormItem>
      </div>
      <FormItem label={"Vertical"}>
        <Select
          isMulti={true}
          name="verticals"
          onChange={(values) => {
            track("paywall_gallery_filter_selected", {
              filter: "verticals",
              values,
            });
          }}
          options={verticals.map((el) => ({
            value:
              el.id === null
                ? el.name.toLowerCase().replace(/ /gi, "-")
                : el.id,
            label: el.name,
          }))}
        />
      </FormItem>
      {/* <FormItem label={"Platform"}>
        <Switch
          name="platform"
          onChange={() => {}}
          options={[
            { value: 1, label: "iOS" },
            { value: 0, label: "Android" },
          ]}
        />
      </FormItem> */}
      <FormItem label={"Has subscription"}>
        <Switch
          name="has_subscription"
          onChange={(values) => {
            track("paywall_gallery_filter_selected", {
              filter: "has_subscription",
              values,
            });
          }}
          options={[
            { value: 1, label: "Yes" },
            { value: 0, label: "No" },
          ]}
        />
      </FormItem>
      <FormItem label={"Has one time purchase"}>
        <Switch
          name="has_one_time_purchase"
          onChange={(values) => {
            track("paywall_gallery_filter_selected", {
              filter: "has_one_time_purchase",
              values,
            });
          }}
          options={[
            { value: 1, label: "Yes" },
            { value: 0, label: "No" },
          ]}
        />
      </FormItem>
      <FormItem label={"Call to action"}>
        <Select
          isMulti={true}
          name="call_to_actions"
          onChange={(values) => {
            track("paywall_gallery_filter_selected", {
              filter: "call_to_actions",
              values,
            });
          }}
          options={callToActions.map((el) => ({
            value:
              el.id === null
                ? el.name.toLowerCase().replace(/ /gi, "-")
                : el.id,
            label: el.name,
          }))}
        />
      </FormItem>
      <FormItem label={"Price inside call-to-action"}>
        <Switch
          name="price_in_call_to_action"
          onChange={(values) => {
            track("paywall_gallery_filter_selected", {
              filter: "price_in_call_to_action",
              values,
            });
          }}
          options={[
            { value: 1, label: "Yes" },
            { value: 0, label: "No" },
          ]}
        />
      </FormItem>
    </Form>
  );
}
